import styled from "styled-components";
export const StateBoxContainer = styled.div`
  width: 100%;
  height: 200px;
  background: ${(props) => (props.bgColorVal ? props.bgColorVal : "white")};
  border-radius: 10px;
  overflow: hidden;
  font-size: 14px;
  font-weight: bold;
  position: relative;
  margin-bottom: 24px;
  .icon-box {
    width: 70px;
    height: 60px;
    background: $primaryColor;
    border-radius: 10px;
  }
  .dashboard-stats-common {
    // align-items: center;
    padding: 20px 20px 20px 20px;
  }
  .state-text-wrap {
    text-align: center;
    padding-top: 20px;
  }
  .stats-icon {
    background: #fff;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    .material-icons {
      width: 35px;
      height: 35px;
    }
  }
  .state-text-wrap {
    .state-text-head {
      color: white;
      font-size: 16px;
      text-transform: uppercase;
      font-weight: 600;
    }
      .state-text-sub-head {
      color: white;
      font-size: 14px;
      text-transform: uppercase;
      font-weight: 600;
      }
    .state-text-subhead {
      color: white;
      font-weight: 700;
      font-size: 25px;
    }
  }
  .stats-footer-text {
    position: absolute;
    bottom: 6px;
    right: 20px;
    font-weight: 400;
    font-size: 17px;
    line-height: 1.57;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #fff;
  }
`;

export const DashboardHeadTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .dashboard-spec-text {
    font-weight: 700;
    font-size: 25px;
    line-height: 1.4;
    color: rgb(34, 51, 84);
    margin-bottom: 0px;
  }
`;

export const DashboardLiveContainer = styled.div`
  margin-bottom: 30px;
  padding: 20px;
  background-color: rgb(255, 255, 255);
  color: rgb(34, 51, 84);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 10px;
  box-shadow: rgba(159, 162, 191, 0.18) 0px 9px 16px,
    rgba(159, 162, 191, 0.32) 0px 2px 2px;
  overflow: hidden;
  position: relative;

  .chart-container {
    height: 300px;
    .chart-container-text {
      background: white;
      border-radius: 10px 10px 0px 0px;
      color: #00133c;
      font-size: 24px;
      padding-top: 12px;
      padding-left: 20px;
      border-bottom: 2px solid #eee;
      padding-bottom: 12px;
    }
  }
`;
export const DemoGraphicContainer = styled.div`
  padding: 0;
  .demo-graph-titleleft {
    display: flex;
    align-items: center;
  }
  .demo-graph-titlelefttext {
    color: #00133c;
    font-size: 24px;
    margin-bottom: 0;
  }
  .card-header {
    background-color: transparent;
  }
`;
export const PopoverContainer = styled.div`
  .popover-head-container {
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-height: 500px;
    overflow: auto;
    padding: 8px 8px 14px 14px;
  }
  .popover-head-container {
    scrollbar-width: thin;
    scrollbar-color: #9155fd transparent;
  }

  .popover-head-container::-webkit-scrollbar {
    width: 2px;
    height: 2px;
  }

  .popover-head-container::-webkit-scrollbar-thumb {
    background-color: #9155fd;
    border-radius: 4px;
  }

  .popover-head-container::-webkit-scrollbar-track {
    background: transparent;
  }

  .popover-main-container {
    position: fixed;
    top: 75px;
    right: 48px;
    z-index: 9999;
    background-color: #f2f5f9;
    border-radius: 8px;
    max-width: 449px;
    min-width: 449px;
  }
  .popover-head-area {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #9155fd;
    padding: 14px 14px 0 14px;
  }
  .popover-title-tag {
    margin: 0;
    color: #000000;
    font-size: 16px;
    font-weight: 600;
    font-family: "Inter", sans-serif;
  }
  .close-modal-button {
    background-color: transparent;
    border: none;
  }
  .popover-container {
    display: flex;
    padding: 10px 12px;
    border-radius: 6px;
    justify-content: space-between;
    background: #e7dafb;
    gap: 9px;
  }
  .popover-container:hover {
    background: #e7dafb;
    cursor: pointer;
  }
  .popover-card-content-left {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
  .popover-card-tagline {
    color: rgb(41, 41, 41);
    font-size: 12px;
    font-weight: 700;
    margin: 0;
    font-family: "Poppins", sans-serif;
  }
  .popover-card-description {
    color: rgb(41, 41, 41);
    font-size: 12px;
    font-weight: 400;
    margin: 0;
    font-family: "Poppins", sans-serif;
  }
  .time-tag {
    display: flex;
    white-space: nowrap;
    align-items: end;
    color: #292929;
    font-size: 10px;
    font-weight: 300;
  }
`;



export const CenteredFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;



export const BalanceContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  flex-wrap: wrap;
  padding-top: 20px;
  text-align: center;
`;

export const BalanceItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 140px;
  padding: 10px 0;

  .balance-title {
    font-size: 0.9rem;
    font-weight: 500;
    color: #333;
    margin-bottom: 6px;
  }

  .balance-amount {
    font-size: 1.3rem;
    font-weight: 600;
    color: #000;
  }
`;

export const FlexBetween = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
`;